import { ApolloClient } from "apollo-client";
import { onError } from "apollo-link-error";
import { setContext } from "apollo-link-context";
import { createHttpLink } from "apollo-link-http";
import { WebSocketLink } from "apollo-link-ws";
import { InMemoryCache } from "apollo-cache-inmemory";
import { getMainDefinition } from "apollo-utilities";
import { split } from "apollo-link";
import Fire from "../../components/firebase/Fire";

let token; //AUTH TOKEN, used for both http and ws auth.

// Create an http link:
const httpLink = createHttpLink({
	uri: process.env.REACT_APP_API
});

// Create a WebSocket link:
let wsLink = new WebSocketLink({
	uri: process.env.REACT_APP_API_WEBSOCKET,
	options: {
		lazy: true,
		reconnect: true,
		connectionParams: async () => {
			return {
				authorization: token ? `Bearer ${token}` : "" //This will be changed later when updating the auth token
			};
		}
	}
});


const authLink = setContext(async (_, { headers }) => {
	// get the authentication token from local storage if it exists
	if (Fire.auth().currentUser) {
		token = await Fire.auth().currentUser.getIdToken(true);
	}
	// return the headers to the context so httpLink can read them
	return {
		headers: {
			...headers,
			authorization: token ? `Bearer ${token}` : ""
		}
	};
});

const protocolLink = split(
	// split based on operation type
	({ query }) => {
		const { kind, operation } = getMainDefinition(query);
		return kind === "OperationDefinition" && operation === "subscription";
	},
	wsLink, //Order is important!!!
	httpLink,
);

const errorLink = onError(({networkError, graphQLErrors}) => {
	console.log('graphQLErrors', graphQLErrors);
	console.log('networkError', networkError)
});

var APIClient = new ApolloClient({
	/* links are like a set of functions to be called one after another
		before each data fetching */
	link: errorLink.concat(authLink.concat(protocolLink)),
	cache: new InMemoryCache(),
});

export default APIClient;

/* 

Usage of the API

import the following inside whereever you want to use the API:

import APIClient from THIS_CURRENT_FILE;
import gql from "graphql-tag";

Once you do so, you should be ready to use the api by calling APIClient functions.

if you want to dive deeper into the client itself, you can check the docs from here:
https://www.apollographql.com/docs/react/api/apollo-client.html

==============================
==============================

To send queries to the api, the general syntax would be:

APIClient.query( {QueryOptions} ).then( response => { MANIPULATE DATA HERE } )

All the QueryOptions can be found in https://www.apollographql.com/docs/react/api/apollo-client.html#ApolloClient.query
For most simple queries, you would need two options only (query and variables).
The 'query' option would contain a gql tag and thats where you put your actual query in, example:

APIClient.query(
	{
		query: 	gql`
					query {
						allSlotsForCompany {
							id
							time
							duration
							status
							firstName
							lastName
							position
						}
					}
				`
	}
).then(response => {
	response.data.YOUR_QUERY_NAME would contain your data
	which in this case it would be response.data.allSlotsForCompany

	If you are not sure what to use or lost in the object encapsulation
	you can always debug or do it the smart way and console.log it
})

the query METHOD (NOT THE VARIABLE) returns a promise, WHICH IS ASYNC (VERY IMPORTANT!!).
check BigCalendar.jsx if you want to see the query in action.

If the query contains variables, then the query must follow the syntax in this doc:
https://graphql.org/learn/queries/#variables

for example: 

APIClient
.query({
	query: gql`
		query interviewAssociatedWithASlot($slotId: ID!) {
			interviewAssociatedWithASlot(slotId: $slotId) {
				id
			}
		}
	`,
	variables: {
		slotId: event.id
	}
})
.then(response => {
	//Do what you want with the response.
});

you can find this example in BigCalendar.jsx

for more info, check the link of the docs written at the start of this comment block.

*/
